import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player/file';
import Confetti from 'react-confetti';
import youGotMoneyImg from 'assets/images/you-got-money-icon.png';
import 'assets/css/shared.css';
import './styles.css';
import './animation.css';
import 'assets/css/video-js.css';

const AnimationViewGoalcardView = (props: Props) => {
  const { goalcard, isFromAffiliateFlow } = props;
  const [animationStarted, setAnimationStarted] = useState(false);
  const [confettiShouldStart, setConfettiShouldStart] = useState(false);
  const [confettiShouldRecycle, setConfettiShouldRecycle] = useState(false);
  const [isReplay] = useState(false);
  const sectionAnimated = useRef(null);
  const { t } = useTranslation();

  const firstFlip = (isFromReplay) => {
    setTimeout(() => {
      setConfettiShouldStart(true);
      if (isFromReplay) {
        setConfettiShouldRecycle(true);
        setTimeout(() => {
          setConfettiShouldRecycle(false);
        }, 3000);
      }
    }, 2000);

    if (isFromReplay) {
      sectionAnimated.current.classList.add('test');
      sectionAnimated.current.classList.add('first-flip');

      setTimeout(() => {
        sectionAnimated.current.classList.remove('showBird');
        sectionAnimated.current.classList.remove('test');
      }, 1500);
    } else {
      sectionAnimated.current.classList.add('first-flip');
    }
  };

  const secondFlip = () => {
    // setSectionAnimatedClasses('animated first-flip second-flip');
    sectionAnimated.current.classList.add('second-flip');

    setTimeout(() => {
      sectionAnimated.current.classList.add('show-controls');
    }, 1200);
  };

  const animateCard = (isFromReplay) => {
    if (!isFromReplay) {
      sectionAnimated.current.classList.add('animated');
    }
    setTimeout(() => {
      firstFlip(isFromReplay);
    }, 1000);

    setTimeout(() => {
      secondFlip();
    }, 5000);
  };

  const replayAnimation = (e) => {
    e.preventDefault();

    sectionAnimated.current.classList.add('ttreplay');
    sectionAnimated.current.classList.remove('show-controls');

    setTimeout(() => {
      setTimeout(() => {
        sectionAnimated.current.classList.remove('first-flip');
      }, 1000);

      setTimeout(() => {
        sectionAnimated.current.classList.add('showBird');
        sectionAnimated.current.classList.remove('second-flip');
      }, 1000);

      setTimeout(() => {
        sectionAnimated.current.classList.remove('ttreplay');

        animateCard(true);
      }, 1000);
    }, 1000);
  };

  useEffect(() => {
    if (animationStarted) {
      return;
    }

    animateCard(isReplay);

    setAnimationStarted(true);
  });

  const buildContentMedia = () => {
    let content;

    if (goalcard.imageURL) {
      content = (
        <div className="image-container">
          <img className="img-responsive" src={goalcard.imageURL} alt="User uploaded" />
        </div>
      );
    } else if (goalcard.fullVideoURL) {
      content = (
        <div className="image-container" id="video-container">
          <ReactPlayer
            url={goalcard.fullVideoURL}
            className="goalcard-video-player"
            // width="100%"
            // height="100%"
            controls
          />
        </div>
      );
    } else {
      content = (
        <div
          className="image-container"
          style={{
            backgroundColor: '#00c0e2',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <div style={{ marginBottom: '20px' }}>
            <img
              src={youGotMoneyImg}
              alt="Img"
              className="img-responsive"
              style={{
                width: '155px',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            />
          </div>
          <div>
            <h2 className="animation-h2">
              {t('goalcard_gotMoney')}
            </h2>
          </div>
        </div>
      );
    }

    return content;
  };

  return (
    <>
      <div className="container">
        <div className="page-content">
          <div className="animation-content">

            <section className="section section-animation" ref={sectionAnimated}>
              <Confetti
                id="confetti-container"
                run={confettiShouldStart}
                recycle={confettiShouldRecycle}
                colors={['#fce18a', '#ff726d', '#b48def', '#f4306d']}
                gravity={0.3}
                numberOfPieces={500}
                tweenDuration={10000}
              />
              <div className="card">
                <div className="flip-container">
                  <div className="flipper">
                    <div className="flip-one-side">
                      <p style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                        {t('goalcard_to')}
                        <span className="card-name">{` ${goalcard.whoIsCardFor}`}</span>
                      </p>
                    </div>
                    <div className="flip-two-side">
                      <div className="image-container">
                        <img src={goalcard.goalcardImg} alt="Img" className="img-responsive" />
                      </div>
                      <div className="card-info">
                        <div className="card-price">
                          <h3>GOALCARD</h3>
                          <p>
                            $
                            {parseFloat(goalcard.amount).toFixed(2)}
                          </p>
                        </div>
                        <div className="card-coord">
                          <p>{t('goalcard_to')}</p>
                          <h3 style={{ wordBreak: 'break-word', overflow: 'hidden' }}>{goalcard.whoIsCardFor}</h3>
                          <p>{t('goalcard_from')}</p>
                          <h3 style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                            {goalcard.investorFullName}
                          </h3>
                          <p>{t('goalcard_for')}</p>
                          <h3 id="body_GoalCard_Goals_Description">
                            {goalcard.internalDescription}
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="flip-three-side">
                      {buildContentMedia()}
                      <div className="message-container">
                        <div
                          className="message"
                        >
                          <h2 className="animation-to-title">
                            {`${t('goalcard_greeting')}${isFromAffiliateFlow === false ? ` ${goalcard.whoIsCardFor}` : ''},`}
                          </h2>
                          <div style={{ width: '100%', height: '100%', overflowY: 'auto' }}>
                            <p>{goalcard.description}</p>
                            <p className="sign">{goalcard.investorFullName}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-control">
                <a href="#replay" onClick={replayAnimation} className={"btn btn-clear section-button " + ( isFromAffiliateFlow ? 'replay-btn' : '')}>
                  <span className="replay-img" />
                  <span>{t('goalcard_replay')}</span>
                </a>
                <a href="#claim" className="btn btn-primary section-button" id="btnClaim2" onClick={(e) => { e.preventDefault(); props.onClaim(); }}>{t('goalcard_claimgift')}</a>
                {
                  isFromAffiliateFlow === false && (
                    <a href="#print" className="btn btn-clear section-button" id="btnPrint" onClick={(e) => { e.preventDefault(); props.onPrint(); }}>
                      <span className="print-img" />
                      <span>{t('goalcard_print')}</span>
                    </a>
                  )
                }                 
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnimationViewGoalcardView;
